import { useTranslation } from 'react-i18next'

import { ObjectiveAggregation, ObjectiveAggregationPer } from 'app/objectives/types'

import { EventList } from '../EventList'
import styles from './ObjectiveCalculation.module.scss'

interface ObjectiveCalculationProps {
  aggregation: ObjectiveAggregation
  eventClassName?: string
  events: string[]
  per: ObjectiveAggregationPer
}

const ObjectiveCalculation = ({
  aggregation,
  eventClassName,
  events,
  per,
}: ObjectiveCalculationProps) => {
  const { t } = useTranslation('objectives')

  return (
    <>
      <span>{aggregation.type === 'count' ? 'Count' : 'Sum'}</span>
      {aggregation.type === 'value' && (
        <>
          {aggregation.targetTrait && (
            <code className={eventClassName}>{aggregation.targetTrait}</code>
          )}
          <span>{t('calculation.over')}</span>
        </>
      )}
      <EventList className={styles.eventList} eventClassName={eventClassName} events={events} />
      <span>{t('calculation.per', { unit: per })}</span>
    </>
  )
}

export default ObjectiveCalculation
